export enum PersonalEnum {
  GeneralInfo = 'General info',
  Address = 'Address',
}
